"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._FitposMapping = void 0;
var available_contracts_module_1 = require("../modules/fitpos/modules/available-contracts.module");
var cancel_contracts_module_1 = require("../modules/fitpos/modules/cancel-contracts.module");
var change_data_module_1 = require("../modules/fitpos/modules/change-data.module");
var customer_data_module_1 = require("../modules/fitpos/modules/customer-data.module");
var manage_modules_module_1 = require("../modules/fitpos/modules/manage-modules.module");
var my_contracts_module_1 = require("../modules/fitpos/modules/my-contracts.module");
var my_modules_module_1 = require("../modules/fitpos/modules/my-modules.module");
var referrals_module_1 = require("../modules/fitpos/modules/referrals.module");
var thank_you_module_1 = require("../modules/fitpos/modules/thank-you.module");
var object_service_1 = require("../services/object-service");
exports._FitposMapping = {
    'change-data': object_service_1.ObjectService.getInstance(change_data_module_1.ChangeDataModule),
    'my-contracts': object_service_1.ObjectService.getInstance(my_contracts_module_1.MyContractsModule),
    'available-contracts': object_service_1.ObjectService.getInstance(available_contracts_module_1.AvailableContractsModule),
    'available-modules': object_service_1.ObjectService.getInstance(available_contracts_module_1.AvailableContractsModule),
    'customer-data': object_service_1.ObjectService.getInstance(customer_data_module_1.CustomerDataModule),
    referrals: object_service_1.ObjectService.getInstance(referrals_module_1.ReferralsModule),
    'cancel-contract': object_service_1.ObjectService.getInstance(cancel_contracts_module_1.CancelContractsModule),
    'thank-you': object_service_1.ObjectService.getInstance(thank_you_module_1.ThankYouModule),
    'manage-modules': object_service_1.ObjectService.getInstance(manage_modules_module_1.ManageModulesModule),
    'my-modules': object_service_1.ObjectService.getInstance(my_modules_module_1.MyModules),
};
